<template>
    <!-- Icono lupa en el menú -->
    <button class="buscador-trigger" @click="abrirModal" aria-label="Buscar">
        <svg class="buscador-trigger-icon" viewBox="0 0 30 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.5439 28.2361L22.1484 20.5625C24.0499 18.3074 25.0917 15.4701 25.0917 12.5162C25.0917 5.61489 19.4635 0 12.5459 0C5.62818 0 0 5.61489 0 12.5162C0 19.4176 5.62818 25.0325 12.5459 25.0325C15.1429 25.0325 17.6177 24.251 19.7335 22.7676L27.1852 30.4994C27.4967 30.8221 27.9156 31 28.3646 31C28.7895 31 29.1926 30.8384 29.4986 30.5445C30.1488 29.9203 30.1695 28.8853 29.5439 28.2361ZM12.5459 3.26511C17.6591 3.26511 21.8189 7.41506 21.8189 12.5162C21.8189 17.6174 17.6591 21.7674 12.5459 21.7674C7.43261 21.7674 3.27283 17.6174 3.27283 12.5162C3.27283 7.41506 7.43261 3.26511 12.5459 3.26511Z"/>
        </svg>
    </button>

    <!-- Modal -->
    <Teleport to="body">
        <div v-if="modalAbierto" class="bm-overlay" @click.self="cerrarModal">
            <div class="bm-modal" role="dialog" aria-modal="true">

                <!-- Cabecera -->
                <div class="bm-header">
                    <div class="bm-input-wrap">
                        <svg class="bm-search-icon" viewBox="0 0 30 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M29.5439 28.2361L22.1484 20.5625C24.0499 18.3074 25.0917 15.4701 25.0917 12.5162C25.0917 5.61489 19.4635 0 12.5459 0C5.62818 0 0 5.61489 0 12.5162C0 19.4176 5.62818 25.0325 12.5459 25.0325C15.1429 25.0325 17.6177 24.251 19.7335 22.7676L27.1852 30.4994C27.4967 30.8221 27.9156 31 28.3646 31C28.7895 31 29.1926 30.8384 29.4986 30.5445C30.1488 29.9203 30.1695 28.8853 29.5439 28.2361ZM12.5459 3.26511C17.6591 3.26511 21.8189 7.41506 21.8189 12.5162C21.8189 17.6174 17.6591 21.7674 12.5459 21.7674C7.43261 21.7674 3.27283 17.6174 3.27283 12.5162C3.27283 7.41506 7.43261 3.26511 12.5459 3.26511Z"/>
                        </svg>
                        <input
                            ref="inputRef"
                            v-model="termino"
                            @input="onInput"
                            @keydown.enter.prevent="redirigirBusqueda"
                            @keydown.esc="cerrarModal"
                            class="bm-input"
                            type="text"
                            placeholder="Buscar productos, servicios, cupones..."
                            autocomplete="off"
                        />
                        <button v-if="termino" class="bm-clear" @click="limpiar" aria-label="Limpiar">
                            <svg viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 1L1 13M1 1l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>
                            </svg>
                        </button>
                    </div>
                    <button class="bm-cerrar" @click="cerrarModal" aria-label="Cerrar">Cancelar</button>
                </div>

                <!-- Cuerpo -->
                <div class="bm-body">

                    <!-- Esperando que termine de escribir -->
                    <div v-if="esperando || cargando" class="bm-estado">
                        <div class="bm-dots">
                            <span></span><span></span><span></span>
                        </div>
                    </div>

                    <!-- Sin resultados -->
                    <div v-else-if="buscado && resultados.length === 0" class="bm-estado">
                        <p class="bm-sin-resultados">No se encontraron resultados para <strong>"{{ terminoBuscado }}"</strong></p>
                    </div>

                    <!-- Resultados -->
                    <ul v-else-if="resultados.length" class="bm-resultados">
                        <li v-for="item in resultados" :key="item.id" class="bm-item">
                            <a :href="item.url" class="bm-item-link">
                                <div class="bm-item-imagen">
                                    <img :src="item.imagen" :alt="item.nombre" />
                                </div>
                                <div class="bm-item-info">
                                    <div class="bm-item-meta">
                                        <span class="bm-badge" :class="'bm-badge--' + item.tipo.toLowerCase().replace('ó','o')">{{ item.tipo }}</span>
                                        <span v-if="item.categoria" class="bm-categoria">{{ item.categoria }}</span>
                                    </div>
                                    <p class="bm-item-nombre">{{ item.nombre }}</p>
                                    <p v-if="item.descripcion" class="bm-item-desc">{{ item.descripcion }}</p>
                                    <span class="bm-item-precio">{{ item.valor }}</span>
                                </div>
                            </a>
                        </li>
                    </ul>

                    <!-- Ver más resultados -->
                    <div v-if="resultados.length" class="bm-ver-mas">
                        <a :href="'/resultados/?texto=' + encodeURIComponent(termino.trim())" class="bm-ver-mas-link">
                            Ver todos los resultados para "{{ terminoBuscado }}"
                        </a>
                    </div>

                    <!-- Estado inicial -->
                    <div v-if="!esperando && !cargando && !buscado && termino.length < 2" class="bm-estado bm-estado--hint">
                        <p>Escribe al menos 2 caracteres para buscar</p>
                    </div>

                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import axios from "axios";

export default {
    name: "BuscadorProductos",
    data() {
        return {
            modalAbierto: false,
            termino: "",
            terminoBuscado: "",
            resultados: [],
            delay: null,
            cargando: false,
            buscado: false,
            esperando: false,
        };
    },
    methods: {
        abrirModal() {
            this.modalAbierto = true;
            document.body.style.overflow = "hidden";
            this.$nextTick(() => {
                this.$refs.inputRef?.focus();
            });
        },
        cerrarModal() {
            this.modalAbierto = false;
            document.body.style.overflow = "";
            this.limpiar();
        },
        limpiar() {
            this.termino = "";
            this.resultados = [];
            this.buscado = false;
            this.esperando = false;
            clearTimeout(this.delay);
        },
        onInput() {
            clearTimeout(this.delay);
            clearInterval(this.countdownInterval);
            this.buscado = false;
            this.resultados = [];

            if (this.termino.length < 2) {
                this.esperando = false;
                this.tiempoRestante = 3;
                return;
            }

            this.esperando = true;

            this.delay = setTimeout(() => {
                this.esperando = false;
                this.ejecutarBusqueda();
            }, 3000);
        },
        ejecutarBusqueda() {
            this.cargando = true;
            this.terminoBuscado = this.termino;

            axios
                .get(`/api/buscador/${encodeURIComponent(this.termino)}`)
                .then((res) => {
                    this.resultados = res.data.data;
                    this.buscado = true;
                })
                .catch(() => {
                    this.resultados = [];
                    this.buscado = true;
                })
                .finally(() => {
                    this.cargando = false;
                });
        },
        redirigirBusqueda() {
            if (this.termino.trim().length >= 2) {
                window.location.href = `/resultados/?texto=${encodeURIComponent(this.termino.trim())}`;
            }
        },
    },
    beforeUnmount() {
        clearTimeout(this.delay);
        document.body.style.overflow = "";
    },
};
</script>

<style scoped>
/* Trigger */
.buscador-trigger {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
}

.buscador-trigger-icon {
    width: 18px;
    height: 18px;
}

/* Overlay */
.bm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    backdrop-filter: blur(3px);
}

/* Modal */
.bm-modal {
    background: #ffffff;
    border-radius: 5px;
    width: 100%;
    max-width: 680px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.2);
}

/* Header */
.bm-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.1rem 1.25rem;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}

.bm-input-wrap {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
}

.bm-search-icon {
    position: absolute;
    left: 0.75rem;
    width: 16px;
    height: 16px;
    color: #9ca3af;
    pointer-events: none;
    flex-shrink: 0;
}

.bm-input {
    width: 100%;
    padding: 0.65rem 2.5rem 0.65rem 2.5rem;
    border: 1.5px solid #e5e7eb;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
    background: #f9fafb;
    color: #111827;
    transition: border-color 0.2s;
}

.bm-input:focus {
    border-color: #111827;
    background: #ffffff;
}

.bm-clear {
    position: absolute;
    right: 0.75rem;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: #9ca3af;
    display: flex;
    align-items: center;
}

.bm-clear svg {
    width: 14px;
    height: 14px;
}

.bm-cerrar {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    color: #6b7280;
    white-space: nowrap;
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    transition: color 0.2s;
}

.bm-cerrar:hover {
    color: #111827;
}

/* Body */
.bm-body {
    overflow-y: auto;
    flex: 1;
}

/* Estado (cargando / sin resultados / hint) */
.bm-estado {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2.5rem 1.5rem;
    gap: 0.75rem;
    color: #6b7280;
    font-size: 0.95rem;
    text-align: center;
}

.bm-estado--hint {
    color: #9ca3af;
}

/* Animación de puntos */
.bm-dots {
    display: flex;
    gap: 6px;
    align-items: center;
}

.bm-dots span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #111827;
    animation: bm-bounce 1.2s infinite ease-in-out;
}

.bm-dots span:nth-child(1) { animation-delay: 0s; }
.bm-dots span:nth-child(2) { animation-delay: 0.2s; }
.bm-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes bm-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40%            { transform: scale(1);   opacity: 1; }
}

/* Resultados */
.bm-resultados {
    list-style: none;
    margin: 0;
    padding: 0.5rem 0;
}

.bm-item {
    border-bottom: 1px solid #f3f4f6;
}

.bm-item:last-child {
    border-bottom: none;
}

.bm-item-link {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 0.85rem 1.25rem;
    text-decoration: none;
    color: inherit;
    transition: background 0.15s;
}

.bm-item-link:hover {
    background: #f9fafb;
}

.bm-item-imagen {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 5px;
    overflow: hidden;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bm-item-imagen img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.bm-item-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.bm-item-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.bm-badge {
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 0.15rem 0.5rem;
    border-radius: 5px;
    background: #e5e7eb;
    color: #374151;
}

.bm-badge--producto  { background: #dbeafe; color: #1d4ed8; }
.bm-badge--servicio  { background: #dcfce7; color: #15803d; }
.bm-badge--oferta    { background: #fef3c7; color: #b45309; }
.bm-badge--cupon     { background: #fce7f3; color: #be185d; }

.bm-categoria {
    font-size: 0.8rem;
    color: #9ca3af;
}

.bm-item-nombre {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bm-item-desc {
    margin: 0;
    font-size: 0.8rem;
    color: #6b7280;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.bm-item-precio {
    font-size: 0.9rem;
    font-weight: 700;
    color: #111827;
}

/* Sin resultados */
.bm-sin-resultados {
    margin: 0;
}

/* Ver más */
.bm-ver-mas {
    padding: 0.75rem 1.25rem 1rem;
    text-align: center;
    border-top: 1px solid #f3f4f6;
}

.bm-ver-mas-link {
    font-size: 0.875rem;
    color: #111827;
    font-weight: 600;
    text-decoration: none;
}

.bm-ver-mas-link:hover {
    text-decoration: underline;
}
</style>
